(function() {
    const money = n => "\xA3" + (Number(n) / 100).toFixed(2),
        esc = s => String(s).replace(/[&<>"']/g, c => ({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        })[c]);

    function askMoney(value) {
        const amount = Number(String(value ?? "").replace(/[^0-9.]/g, ""));
        return Number.isFinite(amount) && amount > 0 ? amount : null
    }

    function listedGrade(title) {
        const text = String(title);
        if (!/CGC/i.test(text)) return "";
        const hit = text.match(/\b(10\.0|9\.9|9\.8|9\.6|9\.4|9\.2|9\.0|8\.5|8\.0|7\.5|7\.0|6\.5|6\.0|5\.5|5\.0|4\.5|4\.0|3\.5|3\.0|2\.5|2\.0|1\.8|1\.5|1\.0|0\.5)\b/);
        return hit ? hit[1] : ""
    }

    function issueHits(title, issue) {
        const number = String(issue || "").replace(/^#/, "").trim();
        return /^\d+$/.test(number) ? new RegExp("#\\s*" + number + "(?!\\d)", "i").test(title) : !0
    }

    function gradeHits(title, grade) {
        if (!grade || grade === "any") return !0;
        const found = listedGrade(title);
        return found !== "" && Number(found) === Number(grade)
    }

    function askGrade(title) {
        const cgc = listedGrade(title);
        if (cgc) return "CGC " + cgc;
        const cond = String(title).match(/\b(NM\+|NM|VF|FN|VG|GD|PR|MT|Raw)\b/i);
        return cond ? cond[1].toUpperCase() : "\u2014"
    }

    function paintAskFigures(box) {
        const picked = (box._asks || []).filter(row => row.picked).map(row => row.price).sort((a, b) => a - b),
            mid = picked.length ? picked.length % 2 ? picked[(picked.length - 1) / 2] : (picked[picked.length / 2 - 1] + picked[picked.length / 2]) / 2 : null,
            text = amount => amount == null ? "\u2014" : "\xA3" + amount.toFixed(2),
            low = box.querySelector("[data-ask-low]"),
            typical = box.querySelector("[data-ask-mid]"),
            high = box.querySelector("[data-ask-high]");
        low && (low.textContent = text(picked[0])), typical && (typical.textContent = text(mid)), high && (high.textContent = text(picked[picked.length - 1]))
    }

    function collectPriceRows(items, filter, sourceLabel) {
        const rows = [];
        for (const item of items || []) {
            const amount = askMoney(item.price);
            const title = item.title;
            const url = item.url;
            if (!title || amount == null || !url || !issueHits(title, filter.issue) || !gradeHits(title, filter.grade)) continue;
            rows.push({
                title,
                price: amount,
                url,
                source: sourceLabel,
                grade: askGrade(title),
                picked: true
            });
        }
        return rows;
    }

    function paintPriceMode(box, mode) {
        const packs = box._pricePacks || {};
        const rows = packs[mode] || [];
        const isSold = mode === "sold";
        const priceLabel = isSold ? "Sold" : "Ask";
        const hint = isSold
            ? "UK sold / completed prices. Tick a sale to include it in Low, Typical, and High."
            : "UK active asking prices. Tick a listing to include it in Low, Typical, and High.";
        const empty = isSold
            ? (packs.soldNote || "No UK sold prices for this search.")
            : (packs.activeNote || "No UK active asking prices for this search.");
        box._asks = rows;
        box._priceMode = mode;
        const modeBar = `<div class="ask-mode" role="tablist" aria-label="Listing type">
            <button type="button" class="chip${mode==="active"?" on":""}" data-ask-mode="active" role="tab" aria-selected="${mode==="active"}">Active listings</button>
            <button type="button" class="chip${mode==="sold"?" on":""}" data-ask-mode="sold" role="tab" aria-selected="${mode==="sold"}">Sold listings</button>
          </div>`;
        if (!rows.length) {
            if (isSold) {
                const needsAccess = packs.soldSource === "insights_needs_access" || /Marketplace Insights|insights_needs_access|invalid_scope|buy\.marketplace\.insights/i.test(empty);
                const soldHint = needsAccess
                    ? "Sold prices use your eBay Marketplace Insights API (not OpenAI). Enable Insights on your eBay developer Production app, then try again — see FIX-SOLD-PRICES.md."
                    : "Sold prices come from the eBay Marketplace Insights API when it is enabled on your Production keys. Low / Typical / High fill automatically once Insights returns matches.";
                box.innerHTML = `<h2 class="ask-title">${esc(box._priceQuery||"")}</h2>${modeBar}
                  <p class="hint">${esc(soldHint)}</p>
                  <p class="empty" style="margin-top:10px">${esc(empty)}</p>`;
                return;
            }
            box.innerHTML = `<h2 class="ask-title">${esc(box._priceQuery||"")}</h2>${modeBar}<p class="empty">${esc(empty)}</p>`;
            return;
        }
        box.innerHTML = `<h2 class="ask-title">${esc(box._priceQuery||"")}</h2>
          ${modeBar}
          <div class="ask-band" aria-live="polite">
            <article class="ask-card"><span>Low</span><strong data-ask-low></strong></article>
            <article class="ask-card"><span>Typical</span><strong data-ask-mid></strong></article>
            <article class="ask-card"><span>High</span><strong data-ask-high></strong></article>
          </div>
          <p class="hint">${esc(hint)}</p>
          <div class="ask-table-wrap"><table class="ask-table">
            <thead><tr><th></th><th>Copy</th><th>Grade</th><th>${priceLabel}</th><th></th></tr></thead>
            <tbody>${rows.map((row,index)=>`<tr>
              <td><input type="checkbox" data-ask-pick="${index}" checked aria-label="Include ${esc(row.title)}"></td>
              <td><a href="${esc(row.url)}" ${row.source==="In the Hub"?"":'target="_blank" rel="noopener noreferrer"'}>${esc(row.title)}</a></td>
              <td>${esc(row.grade)}</td>
              <td>\xA3${row.price.toFixed(2)}</td>
              <td><a class="ask-source" href="${esc(row.url)}" ${row.source==="In the Hub"?"":'target="_blank" rel="noopener noreferrer"'}>${esc(row.source)}</a></td>
            </tr>`).join("")}</tbody>
          </table></div>`;
        paintAskFigures(box);
    }

    function load(key) {
        try {
            const v = JSON.parse(localStorage.getItem(key) || "[]");
            return Array.isArray(v) ? v : []
        } catch {
            return []
        }
    }

    function save(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value))
        } catch {}
    }

    function toast(msg) {
        const t = document.getElementById("toast");
        t && (t.textContent = msg, t.classList.add("show"), clearTimeout(toast._t), toast._t = setTimeout(() => t.classList.remove("show"), 2400))
    }

    function paintWant() {
        const want = load("hub-want");
        document.querySelectorAll("#want-n, #header-want").forEach(el => {
            el.textContent = want.length, el.dataset.n = String(want.length)
        }), document.querySelectorAll("[data-want-handle]").forEach(btn => {
            const on = want.includes(btn.dataset.wantHandle);
            btn.classList.toggle("on", on), btn.classList.contains("quick") ? btn.textContent = on ? "Saved" : "Want" : btn.textContent = on ? "Saved to want list" : "Want"
        })
    }
    document.addEventListener("click", e => {
        const step = e.target.closest("[data-step]");
        if (step) {
            const input = document.getElementById("product-qty");
            input && (input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.step)));
            return
        }
        const pullRemove = e.target.closest("[data-pull-remove]");
        if (pullRemove) {
            const pulls = load("hub-pulls");
            pulls.splice(Number(pullRemove.dataset.pullRemove), 1), save("hub-pulls", pulls), renderPulls();
            return
        }
        const pubBtn = e.target.closest("[data-pub]");
        if (pubBtn) {
            window.hubPub = pubBtn.dataset.pub, applyCollection();
            return
        }
        const w = e.target.closest("[data-want-handle]");
        if (w) {
            const id = w.dataset.wantHandle;
            let want = load("hub-want");
            want.includes(id) ? want = want.filter(x => x !== id) : want.push(id), save("hub-want", want), paintWant(), renderWant(), toast(want.includes(id) ? "Saved to want list" : "Removed from want list")
        }
    });

    function applyCollection() {
        const grid = document.getElementById("col-grid");
        if (!grid) return;
        const q = (document.getElementById("aisle-q").value || "").trim().toLowerCase(),
            avail = document.getElementById("avail-filter").value,
            from = parseFloat(document.getElementById("price-from").value),
            to = parseFloat(document.getElementById("price-to").value),
            cards = [...grid.querySelectorAll(".card")],
            publishers = [...new Set(cards.map(c => c.dataset.vendor).filter(v => v && v.trim().toLowerCase() !== "the comic hub"))],
            tabs = ["All"];
        cards.some(c => c.dataset.signed === "yes") && tabs.push("Signed"), tabs.push(...publishers);
        let pub = window.hubPub || "All";
        tabs.includes(pub) || (pub = "All"), window.hubPub = pub;
        const row = document.getElementById("pub-row");
        row && row.dataset.built !== tabs.join("|") && (row.dataset.built = tabs.join("|"), row.innerHTML = tabs.map(p => `<button type="button" class="chip ${p===pub?"on":""}" data-pub="${esc(p)}">${esc(p)}</button>`).join("")), row.querySelectorAll("[data-pub]").forEach(b => b.classList.toggle("on", b.dataset.pub === pub));
        let shown = 0;
        cards.forEach(card => {
            const title = (card.dataset.title || "").toLowerCase(),
                vendor = card.dataset.vendor || "",
                price = Number(card.dataset.price || 0) / 100,
                status = card.dataset.status || "in";
            let ok = !0;
            (pub === "Signed" && card.dataset.signed !== "yes" || pub !== "All" && pub !== "Signed" && vendor !== pub) && (ok = !1), q && !title.includes(q) && !vendor.toLowerCase().includes(q) && (ok = !1), avail !== "all" && status !== avail && (ok = !1), !Number.isNaN(from) && price < from && (ok = !1), !Number.isNaN(to) && price > to && (ok = !1), card.hidden = !ok, ok && (shown += 1)
        });
        const count = document.getElementById("col-count");
        count && (count.textContent = shown);
        const label = document.getElementById("col-count-label");
        label && (label.textContent = q ? "matching" : "comics");
        const empty = document.getElementById("col-empty");
        empty && (empty.hidden = shown > 0);
        const wider = document.getElementById("search-wider");
        wider && (wider.href = "/search?type=product&q=" + encodeURIComponent(q))
    }
    const aisle = document.getElementById("aisle-form");
    if (aisle) {
        aisle.addEventListener("submit", e => {
            e.preventDefault(), applyCollection()
        }), ["aisle-q", "price-from", "price-to"].forEach(id => {
            const el = document.getElementById(id);
            el && el.addEventListener("input", applyCollection)
        });
        const avail = document.getElementById("avail-filter");
        avail && avail.addEventListener("change", applyCollection);
        const sort = document.getElementById("sort-filter");
        sort && sort.addEventListener("change", () => {
            const url = new URL(location.href);
            url.searchParams.set("sort_by", sort.value), location.href = url.toString()
        }), applyCollection()
    }
    async function renderWant() {
        const root = document.getElementById("want-grid"),
            empty = document.getElementById("want-empty");
        if (!root) return;
        const handles = load("hub-want");
        if (!handles.length) {
            root.innerHTML = "", empty && (empty.hidden = !1);
            return
        }
        const cards = [];
        for (const handle of handles) try {
            const res = await fetch("/products/" + handle + ".js");
            if (!res.ok) continue;
            const p = await res.json(),
                img = p.featured_image ? `<img src="${esc(p.featured_image)}" alt="">` : "";
            cards.push(`<article class="card"><a href="${esc(p.url)}"><div class="card-art">${img}</div></a><div class="card-body"><a class="card-title" href="${esc(p.url)}">${esc(p.title)}</a><div class="card-price">${money(p.price)}</div><div class="card-actions"><button type="button" class="quick want on" data-want-handle="${esc(handle)}">Saved</button></div></div></article>`)
        } catch {}
        root.innerHTML = cards.join(""), empty && (empty.hidden = cards.length > 0)
    }

    function renderPulls() {
        const list = document.getElementById("pull-list"),
            empty = document.getElementById("pull-empty");
        if (!list) return;
        const pulls = load("hub-pulls");
        list.innerHTML = pulls.map((title, i) => `<li><span>${esc(title)}</span><button type="button" class="text-btn" data-pull-remove="${i}">Remove</button></li>`).join(""), empty && (empty.hidden = pulls.length > 0)
    }
    const pullForm = document.getElementById("pull-form");
    pullForm && (pullForm.addEventListener("submit", e => {
        e.preventDefault();
        const input = document.getElementById("pull-input"),
            title = input.value.trim();
        if (!title) return;
        const pulls = load("hub-pulls");
        pulls.push(title), save("hub-pulls", pulls), input.value = "", renderPulls()
    }), renderPulls());
    const priceForm = document.getElementById("price-form");
    async function renderPrices(raw, filter) {
        const box = document.getElementById("price-out");
        if (!box) return;
        const q = (raw || "").trim();
        if (filter = filter || {}, !q) {
            box.innerHTML = '<p class="empty">Search a title to see what we have.</p>';
            return
        }
        const endpoint = (window.HUB_PRICE_URL || "").trim();
        if (endpoint) {
            box.innerHTML = '<p class="empty">Checking UK asking prices\u2026</p>';
            try {
                const join = (base, extra) => base + (base.includes("?") ? "&" : "?") + extra;
                const shopTerm = [filter.title, filter.issue ? "#" + String(filter.issue).replace(/^#/, "") : ""].filter(Boolean).join(" ") || q,
                    shopReq = fetch("/search/suggest.json?q=" + encodeURIComponent(shopTerm) + "&resources[type]=product&resources[limit]=10"),
                    // Active first so the page never waits on sold scrapes.
                    live = await fetch(join(endpoint, "q=" + encodeURIComponent(q) + "&mode=active")),
                    data2 = await live.json();
                if (!live.ok) throw new Error(data2.error || "Price check failed");
                const activeSource = data2.active || data2.ebay || { matches: [] };
                const activeRows = collectPriceRows(activeSource.matches, filter, "UK ask");
                (data2.ai && data2.ai.matches || []).forEach(item => {
                    activeRows.push(...collectPriceRows([item], filter, "UK ask"));
                });
                try {
                    const shop = await (await shopReq).json();
                    activeRows.push(...collectPriceRows(
                        (shop.resources && shop.resources.results && shop.resources.results.products || []).map(p => ({
                            title: p.title,
                            price: p.price,
                            url: p.url
                        })),
                        filter,
                        "In the Hub"
                    ));
                } catch {}
                const asked = [filter.title, filter.issue ? "#" + String(filter.issue).replace(/^#/, "") : "", filter.grade && filter.grade !== "any" ? "CGC " + filter.grade : ""].filter(Boolean).join(" ") || q;
                const soldUrl = `https://www.ebay.co.uk/sch/i.html?_nkw=${encodeURIComponent(q)}&LH_Sold=1&LH_Complete=1&LH_PrefLoc=1&_sop=13`;
                box._priceQuery = q;
                box._pricePacks = {
                    active: activeRows,
                    sold: [],
                    activeNote: activeSource.note || (`No UK active asking prices for ${asked}.`),
                    soldNote: "Loading sold prices from eBay Marketplace Insights…",
                    soldSource: "",
                    soldUrl
                };
                paintPriceMode(box, "active");
                // Fill sold in the background (capped on the worker).
                fetch(join(endpoint, "q=" + encodeURIComponent(q) + "&mode=sold"))
                    .then(r => r.json())
                    .then(soldData => {
                        if (!box._pricePacks || box._priceQuery !== q) return;
                        const soldSource = soldData.sold || {};
                        box._pricePacks.sold = collectPriceRows(soldSource.matches, filter, "UK sold");
                        box._pricePacks.soldNote = soldSource.note || (`No UK sold prices for ${asked}.`);
                        box._pricePacks.soldSource = soldSource.source || "";
                        box._pricePacks.soldUrl = soldSource.ebay_sold_url || soldUrl;
                        if (box._priceMode === "sold") paintPriceMode(box, "sold");
                    })
                    .catch(() => {
                        if (!box._pricePacks || box._priceQuery !== q) return;
                        box._pricePacks.soldNote = "Sold lookup did not finish. Confirm Marketplace Insights is enabled on your eBay Production app, then try again.";
                        box._pricePacks.soldSource = "insights_needs_access";
                        if (box._priceMode === "sold") paintPriceMode(box, "sold");
                    });
            } catch (error) {
                box.innerHTML = `<p class="empty">${esc(error.message||"The price check could not be reached.")}</p>`
            }
            return
        }
        const data = await (await fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8")).json(),
            products = data.resources && data.resources.results && data.resources.results.products || [];
        if (!products.length) {
            box.innerHTML = `<p class="empty">Nothing in the shop for \u201C${esc(q)}\u201D.</p>`;
            return
        }
        box.innerHTML = products.map(p => `<article class="hub-hit"><div class="faux" style="padding:0;overflow:hidden">${p.image?`<img src="${esc(p.image)}" alt="">`:""}</div><div><h2><a href="${esc(p.url)}">${esc(p.title)}</a></h2><p class="card-price">${esc(p.price)}</p><a class="btn" href="${esc(p.url)}">Open book</a></div></article>`).join("")
    }

    function fieldValue(id) {
        const el = document.getElementById(id);
        return el ? el.value.trim() : ""
    }

    function priceQuery() {
        const title = fieldValue("price-title"),
            issue = fieldValue("price-issue").replace(/^#/, ""),
            year = fieldValue("price-year"),
            variant = fieldValue("price-variant"),
            cgc = document.getElementById("price-cgc"),
            signed = document.getElementById("price-signed"),
            signer = fieldValue("price-signer");
        if (!title) return toast("Add the comic title"), "";
        if (!issue) return toast("Add the issue number"), "";
        const pressed = el => el && el.getAttribute("aria-pressed") === "true";
        if (pressed(signed) && !signer) return toast("Add the name on the signature"), "";
        const parts = [title, "#" + issue];
        if (year && parts.push(year), variant && parts.push(variant), pressed(cgc)) {
            const picked = document.querySelector("#price-grades [data-grade].on"),
                grade = picked ? picked.dataset.grade : "any";
            parts.push(grade === "any" ? "CGC" : "CGC " + grade)
        }
        return pressed(signed) && parts.push("signed " + signer), parts.join(" ")
    }
    if (priceForm) {
        const grades = document.getElementById("price-grades"),
            signerWrap = document.getElementById("price-signer-wrap"),
            cgcBox = document.getElementById("price-cgc"),
            signedBox = document.getElementById("price-signed"),
            syncPriceExtras = () => {
                grades && (grades.hidden = !(cgcBox && cgcBox.getAttribute("aria-pressed") === "true")), signerWrap && (signerWrap.hidden = !(signedBox && signedBox.getAttribute("aria-pressed") === "true"))
            },
            setPressed = (btn, on) => {
                btn && (btn.setAttribute("aria-pressed", on ? "true" : "false"), btn.classList.toggle("on", on))
            },
            togglePick = btn => {
                btn && (setPressed(btn, btn.getAttribute("aria-pressed") !== "true"), syncPriceExtras())
            };
        cgcBox && cgcBox.addEventListener("click", () => togglePick(cgcBox)), signedBox && signedBox.addEventListener("click", () => togglePick(signedBox));
        const selectGrade = grade => {
            if (!grades) return;
            const buttons = [...grades.querySelectorAll("[data-grade]")],
                target = buttons.find(el => el.dataset.grade === grade) || buttons.find(el => el.dataset.grade === "any");
            buttons.forEach(el => {
                const on = el === target;
                el.classList.toggle("on", on), el.setAttribute("aria-pressed", on ? "true" : "false")
            })
        };
        grades && grades.addEventListener("click", e => {
            const btn = e.target.closest("[data-grade]");
            btn && selectGrade(btn.dataset.grade)
        });
        const photo = document.getElementById("price-photo"),
            photoNote = document.getElementById("price-photo-note"),
            shrinkImage = file => new Promise((resolve, reject) => {
                const img = new Image,
                    url = URL.createObjectURL(file);
                img.onload = () => {
                    const scale = Math.min(1, 768 / Math.max(img.width, img.height)),
                        canvas = document.createElement("canvas");
                    canvas.width = Math.max(1, Math.round(img.width * scale)), canvas.height = Math.max(1, Math.round(img.height * scale)), canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height), URL.revokeObjectURL(url), resolve(canvas.toDataURL("image/jpeg", .72))
                }, img.onerror = () => {
                    URL.revokeObjectURL(url), reject(new Error("Could not read that photo."))
                }, img.src = url
            });
        photo && photo.addEventListener("change", async () => {
            const file = photo.files && photo.files[0];
            if (photo.value = "", !file) return;
            const endpoint = (window.HUB_PRICE_URL || "").trim();
            if (!endpoint) {
                toast("Photo check is not available yet");
                return
            }
            photoNote && (photoNote.hidden = !1, photoNote.textContent = "Reading the cover\u2026");
            try {
                const image = await shrinkImage(file),
                    identify = endpoint.replace(/\/price\/?(?:\?.*)?$/, "/identify"),
                    res = await fetch(identify, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            image
                        })
                    }),
                    data = await res.json();
                if (!res.ok) {
                    const raw = data.error || "Could not read that photo.";
                    throw new Error(/credit/i.test(raw) ? "Photo reading is paused. Try the title and issue instead." : raw)
                }
                const title = document.getElementById("price-title"),
                    issue = document.getElementById("price-issue"),
                    year = document.getElementById("price-year"),
                    cover = document.getElementById("price-variant"),
                    signer = document.getElementById("price-signer");
                if (title && (title.value = data.series || ""), issue && (issue.value = data.issue || ""), year && (year.value = data.year || ""), cover && (cover.value = data.cover || ""), signer && (signer.value = data.signer || ""), setPressed(cgcBox, !!data.cgc), setPressed(signedBox, !!data.signed && !!data.signer), selectGrade(data.grade || "any"), syncPriceExtras(), data.signed && !data.signer) {
                    setPressed(signedBox, !0), syncPriceExtras(), photoNote && (photoNote.textContent = "A signature is on the photo. Add the name, then check the price.");
                    return
                }
                photoNote && (photoNote.textContent = data.series ? "Filled from the photo. Change anything that looks wrong." : "Could not read a title from that photo.");
                const q = priceQuery();
                q && renderPrices(q, {
                    title: fieldValue("price-title"),
                    issue: fieldValue("price-issue").replace(/^#/, ""),
                    grade: data.cgc ? data.grade || "any" : ""
                })
            } catch (error) {
                const message = error && error.message === "Failed to fetch" ? "The photo check could not reach Cloudflare. Deploy the updated script, then try again." : error.message || "Could not read that photo.";
                photoNote && (photoNote.textContent = message)
            }
        }), priceForm.addEventListener("submit", e => {
            e.preventDefault();
            const q = priceQuery();
            if (!q) return;
            const pressed = el => el && el.getAttribute("aria-pressed") === "true",
                cgcBox2 = document.getElementById("price-cgc");
            renderPrices(q, {
                title: fieldValue("price-title"),
                issue: fieldValue("price-issue").replace(/^#/, ""),
                grade: pressed(cgcBox2) ? ((document.querySelector("#price-grades [data-grade].on") || {}).dataset || {}).grade || "any" : ""
            })
        });
        const clear = document.getElementById("price-clear");
        clear && clear.addEventListener("click", () => {
            priceForm.reset(), [cgcBox, signedBox].forEach(btn => {
                btn && (btn.setAttribute("aria-pressed", "false"), btn.classList.remove("on"))
            }), grades && grades.querySelectorAll("[data-grade]").forEach(el => {
                const on = el.dataset.grade === "any";
                el.classList.toggle("on", on), el.setAttribute("aria-pressed", on ? "true" : "false")
            }), syncPriceExtras(), photoNote && (photoNote.hidden = !0, photoNote.textContent = "");
            const box = document.getElementById("price-out");
            box && (box.innerHTML = "", box._asks = null, box._pricePacks = null, box._priceMode = null)
        });
        const out = document.getElementById("price-out");
        out && out.addEventListener("change", e => {
            const input = e.target.closest("[data-ask-pick]");
            !input || !out._asks || (out._asks[Number(input.dataset.askPick)].picked = input.checked, paintAskFigures(out))
        });
        out && out.addEventListener("click", e => {
            const btn = e.target.closest("[data-ask-mode]");
            if (!btn || !out._pricePacks) return;
            const mode = btn.dataset.askMode;
            if (mode === out._priceMode) return;
            paintPriceMode(out, mode);
        })
    }
    const deals = (document.querySelector('form[action*="contact"] #deal-tags'), document.getElementById("deal-tags")),
        dealForm = deals && deals.closest("form");
    dealForm && dealForm.addEventListener("submit", e => {
        const names = [...dealForm.querySelectorAll('input[type="checkbox"]:checked')].map(i => i.name);
        if (!names.length) {
            e.preventDefault(), toast("Tick at least one kind of deal");
            return
        }
        const tags = ["exclusive-deals"].concat(names);
        document.getElementById("deal-tags").value = tags.join(",")
    });

    function clock(show) {
        return String(show.h).padStart(2, "0") + ":" + String(show.m).padStart(2, "0")
    }

    function liveShow(now, shows2) {
        return shows2.find(show => {
            if (now.getDay() !== show.dow) return !1;
            const start = new Date(now);
            start.setHours(show.h, show.m, 0, 0);
            const end = new Date(start.getTime() + 10800 * 1e3);
            return now >= start && now <= end
        }) || null
    }

    function upcoming(now, shows2) {
        const live = liveShow(now, shows2);
        if (live) {
            const start = new Date(now);
            return start.setHours(live.h, live.m, 0, 0), Object.assign({}, live, {
                start,
                end: new Date(start.getTime() + 10800 * 1e3),
                live: !0
            })
        }
        let best = null;
        return shows2.forEach(show => {
            const start = new Date(now),
                delta = (show.dow - now.getDay() + 7) % 7;
            start.setDate(now.getDate() + delta), start.setHours(show.h, show.m, 0, 0), start <= now && start.setDate(start.getDate() + 7), (!best || start < best.start) && (best = Object.assign({}, show, {
                start,
                live: !1
            }))
        }), best
    }

    function remain(ms) {
        const s = Math.max(0, Math.floor(ms / 1e3)),
            h = Math.floor(s / 3600),
            m = Math.floor(s % 3600 / 60),
            sec = s % 60;
        return h ? h + "h " + String(m).padStart(2, "0") + "m" : m + "m " + String(sec).padStart(2, "0") + "s"
    }
    const showsEl = document.getElementById("hub-shows");
    let shows = [];
    try {
        shows = showsEl ? JSON.parse(showsEl.textContent || "[]") : []
    } catch {
        shows = []
    }
    const calCursor = new Date;
    calCursor.setDate(1);

    function paintLive() {
        if (!shows.length) return;
        const now = new Date,
            show = upcoming(now, shows),
            live = !!(show && show.live);
        document.querySelectorAll(".live-dot").forEach(d => d.classList.toggle("on", live));
        const stickyText = document.getElementById("sticky-live-text");
        if (stickyText && show) {
            const tonight2 = show.start.toDateString() === now.toDateString();
            stickyText.textContent = live ? "Live now \xB7 " + show.name : tonight2 ? "Tonight \xB7 " + show.name : show.start.toLocaleDateString("en-GB", {
                weekday: "short"
            }) + " \xB7 " + show.name
        }
        const kicker = document.getElementById("up-kicker");
        if (!kicker || !show) return;
        const tonight = show.start.toDateString() === now.toDateString();
        kicker.textContent = live ? "Live now" : tonight ? "Tonight" : "Next", document.getElementById("up-name").textContent = show.name, document.getElementById("up-meta").textContent = show.label + " \xB7 " + clock(show) + " \xB7 " + (live ? remain(show.end - now) + " left" : "in " + remain(show.start - now));
        const join = document.getElementById("up-join");
        show.url && (join.href = show.url), join.textContent = show.join || "Join";
        const grid = document.getElementById("cal-grid"),
            title = document.getElementById("cal-title");
        if (!grid || !title) return;
        title.textContent = calCursor.toLocaleDateString("en-GB", {
            month: "long",
            year: "numeric"
        });
        const year = calCursor.getFullYear(),
            month = calCursor.getMonth(),
            today = new Date(now.getFullYear(), now.getMonth(), now.getDate()),
            lead = (new Date(year, month, 1).getDay() + 6) % 7,
            days = new Date(year, month + 1, 0).getDate();
        let html = "";
        for (let i = 0; i < lead; i++) html += '<div class="cal-cell cal-empty"></div>';
        for (let day = 1; day <= days; day++) {
            const date = new Date(year, month, day),
                past = date < today,
                dayShows = shows.filter(item => item.dow === date.getDay()),
                lines = dayShows.map(item => {
                    const reg = past || !item.url ? "" : `<a class="cal-reg" href="${esc(item.url)}" target="_blank" rel="noopener noreferrer">Join</a>`;
                    return `<div class="cal-show"><strong>${esc(item.name)}</strong><span class="cal-time">${clock(item)}</span>${reg}</div>`
                }).join("");
            html += `<div class="cal-cell${past?" past":""}${date.getTime()===today.getTime()?" today":""}${dayShows.length?" has":""}"><span class="cal-day">${day}</span>${lines}</div>`
        }
        grid.innerHTML = html
    }
    if (shows.length) {
        const prev = document.getElementById("cal-prev"),
            next = document.getElementById("cal-next");
        prev && prev.addEventListener("click", () => {
            calCursor.setMonth(calCursor.getMonth() - 1), paintLive()
        }), next && next.addEventListener("click", () => {
            calCursor.setMonth(calCursor.getMonth() + 1), paintLive()
        }), paintLive(), setInterval(paintLive, 1e3)
    }

    function paintHubReviews() {
        const counter = document.querySelector(".reputon-feedback-counter"),
            count = document.querySelector(".reputon-reviews-count");
        if (!counter || !count) return !1;
        const score = counter.textContent.replace(/\s+/g, " ").trim(),
            reviews = count.textContent.replace(/\s+/g, " ").trim();
        if (!score || !reviews) return !1;
        const line = score + " positive \xB7 " + reviews;
        return document.querySelectorAll("[data-hub-review-score]").forEach(el => {
            el.textContent = score
        }), document.querySelectorAll("[data-hub-review-count]").forEach(el => {
            el.textContent = reviews
        }), document.querySelectorAll("[data-hub-review-line]").forEach(el => {
            const star = el.querySelector(".star");
            star ? (el.textContent = "", el.appendChild(star), el.appendChild(document.createTextNode(" " + line))) : el.textContent = line
        }), document.querySelectorAll("[data-hub-review-bar]").forEach(el => {
            el.hidden = !1
        }), !0
    }
    const reviewStarted = Date.now(),
        reviewTimer = setInterval(() => {
            (paintHubReviews() || Date.now() - reviewStarted > 12e3) && clearInterval(reviewTimer)
        }, 400);
    paintWant(), renderWant(), document.querySelectorAll("#cart-n, #header-cart").forEach(el => {
        el.dataset.n = el.textContent.trim()
    });
    // Refresh old theme copy now that Active + Sold are both available.
    document.querySelectorAll("p, .hero-lead, .hint, .muted").forEach(el => {
        const text = el.textContent || "";
        if (/UK asking prices, not sold prices/i.test(text)) {
            el.textContent = text.replace(
                /These are UK asking prices, not sold prices\.?/i,
                "Use Active listings for current asks, or Sold listings for completed sales."
            );
        }
    });
})();